import { useMemo } from "react";
import { AgGridReact } from "@jsq/ds/core";
import { AccessTypeComponent } from "~/pages/Dashboard/components/WorkspaceTable/CellComponents";
import { WorkspaceUserData } from "../../../types";
import { CellWithAction, RoleCell, StatusCell } from "./CellComponents";

interface UseWorkspaceUsersTableProps {
  onRemoveUser: (user: WorkspaceUserData | null) => void;
}

export const useWorkspaceUsersTableAgGridOptions = ({
  onRemoveUser,
}: UseWorkspaceUsersTableProps) => {
  const colDefs: AgGridReact.AgGridReactProps["columnDefs"] = useMemo(() => {
    return [
      {
        field: "userName",
        headerName: "Employee",
        width: 150,
        filter: "agTextColumnFilter",
      },
      {
        field: "userEmail",
        headerName: "Email",
        filter: "agTextColumnFilter",
      },
      {
        field: "roleGroupName",
        headerName: "Role",
        cellRenderer: RoleCell,
      },
      {
        field: "accessType",
        headerName: "Assignment type",
        width: 100,
        cellRenderer: AccessTypeComponent,
      },
      {
        field: "active",
        headerName: "Status",
        cellRenderer: StatusCell,
        width: 100,
      },
      {
        field: "lastAccessTimestamp",
        headerName: "Last accessed",
        cellRenderer: CellWithAction,
        cellRendererParams: {
          onRemoveUser,
        },
      },
    ];
  }, []);

  return { colDefs };
};
